export default {
  ChangeLayerType: 'changeLayerType',
  RowCountChange: 'rowCountChange',
  QueryChange: 'queryChange',
  GridModeChange: 'gridModeChange',
  VisibilityChange: 'visibilityChange'
}
